<template>
  <div >

    <div  v-if="faktur || faktur != null" class="md-layout noprint">
       
      <md-toolbar class="color md-dense" style="width:100%">
        <div style="width:50%">
          <h3 class="md-title" style="flex:1;">
          </h3>
        </div>
        <div style="width:50%; ">
          <div class="md-toolbar-section-end">
            <md-button class="noprint md-dense color md-icon-button" @click="printPage()" ><md-icon>print</md-icon></md-button>
            <!-- <md-menu md-direction="bottom-start" style="margin-right:20px;">
              <md-button class="nonprint; md-info md-dense md-icon-button" md-menu-trigger><md-icon>more_vert</md-icon></md-button>
              <md-menu-content>
                <md-menu-item v-if="role.update" @click="editFaktur(faktur.id)">Edit</md-menu-item>
                <md-menu-item v-if="role.delete" @click="deleteConfirmation(faktur.id)">Delete</md-menu-item>
              </md-menu-content>
            </md-menu> -->
            <md-button class="md-icon-button  color md-info" @click="closeDetail()"><md-icon>close</md-icon></md-button>
          </div>
        </div>
      </md-toolbar>
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head><b>Faktur No</b></md-table-head>
                <md-table-head><b>Tanggal Faktur</b></md-table-head>
                <md-table-head><b>Service Estimate No</b></md-table-head>
                <md-table-head><b>PKB No.</b></md-table-head>
                <md-table-head><b>Tgl Masuk</b></md-table-head>
                <md-table-head><b>Tgl Selesai</b></md-table-head>
                <md-table-head><b>SA Kontak</b></md-table-head>
                <md-table-head><b>Kasir</b></md-table-head>
              </md-table-row>
              <md-table-row>
                <md-table-cell>{{faktur.faktur_no}}</md-table-cell>
                <md-table-cell>{{faktur.faktur_invoice_datetime}}</md-table-cell>
                <md-table-cell>{{faktur.faktur_pkb.service_estimate.service_estimate_no}}</md-table-cell>
                <md-table-cell>{{faktur.faktur_pkb.pkb_no}}</md-table-cell>
                <md-table-cell>{{faktur.faktur_date_in}}</md-table-cell>
                <md-table-cell>{{faktur.faktur_date_out}}</md-table-cell>
                <md-table-cell>
                  <span v-if="faktur.faktur_sa_contact==null"> - </span>
                  <span v-else>{{faktur.faktur_sa_contact}}</span>
                </md-table-cell>
                <md-table-cell>{{faktur.faktur_kasir_name.name}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>

      <!-- <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Client & Vehicle Info</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table >
              <md-table-row>
                <md-table-cell style="text-align:left; font-weight:bold; width:120px;">Plat No</md-table-cell>
                <md-table-cell style="width:150px;">{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_plate_no}}</md-table-cell>

                <md-table-cell style="text-align:left; font-weight:bold; width:150px;">Client No</md-table-cell>
                <md-table-cell style="width:150px;">{{ faktur.faktur_pkb.service_estimate.client.client_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="text-align:left; font-weight:bold; width:120px;">Merk/Type</md-table-cell>
                <md-table-cell style="width:150px;">{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_type.vehicle_brands.vehicle_brand_name+", "+ faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_type.vehicle_model+" "+faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_type.vehicle_year_model}}</md-table-cell>

                <md-table-cell style="text-align:left; font-weight:bold; width:150px;">Client Name</md-table-cell>
                <md-table-cell style="width:150px;">{{ faktur.faktur_pkb.service_estimate.client.client_name}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="text-align:left; font-weight:bold; width:120px;">Engine No</md-table-cell>
                <md-table-cell style="width:150px;">{{faktur.faktur_pkb.service_estimate.service_estimate_engine_no}}</md-table-cell>

                <md-table-cell style="text-align:left; font-weight:bold; width:150px;">Phone</md-table-cell>
                <md-table-cell style="width:150px;">{{ faktur.faktur_pkb.service_estimate.client.client_phone}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="text-align:left; font-weight:bold; width:120px;">Chassis No</md-table-cell>
                <md-table-cell style="width:150px;">{{faktur.faktur_pkb.service_estimate.service_estimate_chasis_no}}</md-table-cell>

                <md-table-cell style="text-align:left; font-weight:bold; width:150px;">Email</md-table-cell>
                <md-table-cell style="width:150px;">{{ faktur.faktur_pkb.service_estimate.client.client_email}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="text-align:left; font-weight:bold; width:120px;">Warna</md-table-cell>
                <md-table-cell style="width:150px;">{{faktur.faktur_pkb.service_estimate.service_estimate_customer_color}}</md-table-cell>

                <md-table-cell style="text-align:left; font-weight:bold; width:150px;">Address</md-table-cell>
                <md-table-cell style="width:150px;">{{ faktur.faktur_pkb.service_estimate.client.client_address}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="text-align:left; font-weight:bold; width:120px;">Tahun</md-table-cell>
                <md-table-cell colspan="3">{{faktur.faktur_pkb.service_estimate.service_estimate_customer_year}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="text-align:left; font-weight:bold; width:120px;">KM Masuk</md-table-cell>
                <md-table-cell colspan="3">{{faktur.faktur_customer_km_in}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="text-align:left; font-weight:bold; width:120px;">KM Keluar</md-table-cell>
                <md-table-cell colspan="3">{{faktur.faktur_customer_km_out}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div> -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Client</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Client No</md-table-cell>
                <md-table-cell>{{ faktur.faktur_pkb.service_estimate.client.client_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Client Name</md-table-cell>
                <md-table-cell>{{ faktur.faktur_pkb.service_estimate.client.client_name}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Phone</md-table-cell>
                <md-table-cell>{{ faktur.faktur_pkb.service_estimate.client.client_phone}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Email</md-table-cell>
                <md-table-cell>{{ faktur.faktur_pkb.service_estimate.client.client_email}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Address</md-table-cell>
                <md-table-cell>{{ faktur.faktur_pkb.service_estimate.client.client_address}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Vehicle</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Plat No</md-table-cell>
                <md-table-cell>{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_plate_no}}</md-table-cell>
              </md-table-row>
                <md-table-row>
                <md-table-cell style="font-weight:bold;">Merk/Type</md-table-cell>
                <md-table-cell>{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_brands.vehicle_brand_name+", "+ faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_model+" "+faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_year_model}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Engine No</md-table-cell>
                <md-table-cell>{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_engine_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Chassis No</md-table-cell>
                <md-table-cell>{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_chassis_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Warna</md-table-cell>
                <md-table-cell v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 0">Putih</md-table-cell>
                <md-table-cell v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 1">Putih Kuning</md-table-cell>
                <md-table-cell v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 2">Putih Metalik</md-table-cell>
                <md-table-cell v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 3">Hitam</md-table-cell>
                <md-table-cell v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 4">Hitam Metalik</md-table-cell>
                <md-table-cell v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 5">Silver</md-table-cell>
                <md-table-cell v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 6">Silver Metalik</md-table-cell>
                <md-table-cell v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 7">Abu Abu</md-table-cell>
                <md-table-cell v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 8">Abu Abu Metalik</md-table-cell>
                <md-table-cell v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 9">Hijau</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">Tahun</md-table-cell>
                <md-table-cell>{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_registration_year}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">KM Masuk</md-table-cell>
                <md-table-cell>{{faktur.faktur_customer_km_in}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold;">KM Keluar</md-table-cell>
                <md-table-cell>{{faktur.faktur_customer_km_out}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>

      
      <div class="md-layout-item md-size-100 ">
        <md-card >
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Tagihan dan Biaya</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head style="text-align:center;"><b>Total Biaya Jasa</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Total Biaya SparePart</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Subtotal</b></md-table-head>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="text-align:center;">Rp. {{formatPrice(faktur.faktur_total_biaya_jasa)}}</md-table-cell>
                <md-table-cell style="text-align:center;">Rp. {{formatPrice(faktur.faktur_total_biaya_spare_part)}}</md-table-cell>
                <md-table-cell><span style="float: left;">Rp.</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_jasa + faktur.faktur_total_biaya_spare_part)}}</span></md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell></md-table-cell>
                <md-table-cell style="text-align:center; font-weight:bold;">PPN 11%</md-table-cell>
                <md-table-cell>
                  <span style="float: left; font-weight:bold;">Rp.</span><span style="float: right; font-weight:bold;">{{formatPrice(faktur.faktur_ppn)}}</span>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell></md-table-cell>
                <md-table-cell style="text-align:center; font-weight:bold;">Materai</md-table-cell>
                <md-table-cell>
                  <span style="float: left; font-weight:bold;">Rp.</span><span style="float: right; font-weight:bold;">{{formatPrice(faktur.faktur_materai)}}</span>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell></md-table-cell>
                <md-table-cell style="text-align:center; font-weight:bold;">Total</md-table-cell>
                <md-table-cell>
                  <span style="float: left; font-weight:bold;">Rp.</span><span style="float: right; font-weight:bold;">{{formatPrice(faktur.faktur_total_biaya_jasa + faktur.faktur_total_biaya_spare_part + faktur.faktur_materai + faktur.faktur_ppn)}}</span>
                </md-table-cell>
              </md-table-row>
            </md-table>
            <!-- <md-table >
              <md-table-row >
                <md-table-cell style="font-weight:bold; padding-left: 25mm; padding-top: 5mm; font-size:25px;"> TOTAL BIAYA JASA</md-table-cell>
                <md-table-cell >
                  <span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_jasa)}}</span>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold; padding-left: 25mm; padding-top: 5mm; font-size:25px;">TOTAL BIAYA SPARE PART</md-table-cell>
                <md-table-cell >
                  <span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_spare_part)}}</span>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="text-align:right;"><b>Sub Total</b></md-table-cell>
                <md-table-cell >
                  <span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_jasa + faktur.faktur_total_biaya_spare_part)}}</span>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="text-align:right;"><b>PPN 10%</b></md-table-cell>
                <md-table-cell >
                  <span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_ppn)}}</span>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="text-align:right;"><b>Materai</b></md-table-cell>
                <md-table-cell >
                  <span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_materai)}}</span>
                </md-table-cell>
              </md-table-row>
              <md-table-row >
                <md-table-cell  style="text-align:right; font-weight:bold;">TOTAL</md-table-cell>
                <md-table-cell >
                  <span style="float: left; font-weight:bold;">Rp</span><span style="float: right; font-weight:bold;">{{formatPrice(faktur.faktur_total_biaya_jasa + faktur.faktur_total_biaya_spare_part + faktur.faktur_materai + faktur.faktur_ppn)}}</span>
                </md-table-cell>
              </md-table-row>
            </md-table> -->
          </md-card-content>
        </md-card>
      </div>
    </div>
 
    <div  v-if="faktur || faktur != null" class="md-layout print">
      <div class="md-layout-item md-size-100">
          <md-content>
            <table class="noprint" style="width: 100%; table-layout: fixed; text-transform: capitalize ;">
              <colgroup>
                <col style="width: 7mm">
                <col style="width: 18mm">
                <col style="width: 20mm">
                <col style="width: 120mm">
                <col style="width: 15mm">
              </colgroup>
              <tr>
                <td ></td>
                <td></td>
                <td ></td>
                <td><md-button style="float: right; " class="noprint" @click="printPage()" ><md-icon>print</md-icon></md-button></td>
                <td >
                  <md-menu md-direction="bottom-start">
                    <md-button class="nonprint; md-info" md-menu-trigger>Option</md-button>
                    <md-menu-content>
                      <md-menu-item v-if="role.update" @click="editFaktur(faktur.id)">Edit</md-menu-item>
                      <md-menu-item v-if="role.delete" @click="deleteConfirmation(faktur.id)">Delete</md-menu-item>
                      <!-- <md-menu-item @click="backtoList">Back to Faktur list</md-menu-item> -->
                    </md-menu-content>
                  </md-menu>
                </td>
              </tr>
              
            </table>
            <table class="print" style="width:100%; table-layout: fixed; border: 1px solid black;" >
              <tr>
                <td style="width:25%; border: 1px solid black;"  rowspan="4"><img src="@/assets/images/logocharged.png" style="width:100%;"></td>
                <td style="padding-left:10mm; font-size: 4mm;  font-weight: 900; text-decoration: underline;">CHARGED INDONESIA</td>
              </tr>
              <tr>
                <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 1100;">Jakarta</td>
              </tr>
              <tr>
                <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 900;">Jl. Kemang Utara VII No.21B, Bangka, Kec. Mampang Prpt., Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12730</td>
              </tr>
              <tr>
                <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 900;">Phone : 081280004426</td>
              </tr>
            </table>
            <table  style="width:100%; border-collapse: collapse; margin-top:5px;">
              <colgroup>
                <col style="width: 140mm">
                <col style="width: 40mm">
              </colgroup>
              <tr>
                <td style="font-size: 3.5mm;  font-weight: 900; border:1px solid black;">F A K T U R</td>
                <td style="border:1px solid black; padding-left:3mm" class="bd-left">{{faktur.faktur_no}}</td>
              </tr>
            </table>

            <table class="table-inside-td" style="width:100%; table-layout: fixed; border: 1px solid black; margin-top: 2px;" >
                  <colgroup>
                      <col style="width: 15mm">
                      <col style="width: 2mm">
                      <col style="width: 31mm">
                      <col style="width: 23mm">
                      <col style="width: 2mm">
                      <col style="width: 23mm">
                    </colgroup>
                    
                  <tr>
                    <td class="bold-title">Tgl. Faktur</td>
                    <td>:</td>
                    <td>{{faktur.faktur_invoice_datetime}}</td>
                    <td class="bold-title" style="text-align:right;">No. PKB</td>
                    <td>:</td>
                    <td>{{faktur.faktur_pkb.pkb_no}}</td>
                    
                  </tr>
                    
                  </table>

            <!-- <table style="table-layout: fixed;  margin-top: 2px; width:100%;" >
              <tr>
                <td style="width:65mm; vertical-align:top;">
                  
                </td>
                <td style="width:115mm"> -->
                  <table class="table-inside-td" style="table-layout: fixed; width:100%; table-layout: fixed; border: 1px solid black; margin-top: 2px;" >
                    <colgroup>
                      <col style="width: 22mm">
                      <col style="width: 2mm">
                      <col style="width: 70mm">
                      <col style="width: 27mm">
                      <col style="width: 2mm">
                      <col style="width: 33mm">
                    </colgroup>
                    <tr>
                      <td class="bold-title">Nama</td>
                      <td>:</td>
                      <td colspan="3">{{faktur.faktur_pkb.service_estimate.client.client_name}}</td>
                    </tr>
                    <tr>
                      <td class="bold-title">Alamat</td>
                      <td>:</td>
                      <td colspan="8">{{faktur.faktur_pkb.service_estimate.client.client_address}}</td>
                    </tr>
                    <tr>
                      <td class="bold-title">Email</td>
                      <td>:</td>
                      <td colspan="8">{{faktur.faktur_pkb.service_estimate.client.client_email}}</td>
                    </tr>
                    <tr>
                      <td class="bold-title">No. Polisi</td>
                      <td>:</td>
                      <td>{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_plate_no}}</td>
                      <td class="bold-title">No. Rangka</td>
                      <td>:</td>
                      <td colspan="2">{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_chassis_no}}</td>
                      
                      
                    </tr>
                    <tr>
                      <td class="bold-title">Merek</td>
                      <td>:</td>
                      <td>{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_brands.vehicle_brand_name+", "+ faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_model+" "+faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_year_model}}</td>
                      <td class="bold-title">Warna</td>
                      <td>:</td>
                      <td>
                        <span v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color==0">Putih</span>
                        <span v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color==1">Putih Kuning</span>
                        <span v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color==2">Putih Metalik</span>
                        <span v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color==3">Hitam</span>
                        <span v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color==4">Hitam Metalik</span>
                        <span v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color==5">Silver</span>
                        <span v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color==6">Silver Metalik</span>
                        <span v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color==7">Abu Abu</span>
                        <span v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color==8">Abu Abu Metalik</span>
                        <span v-if="faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color==9">Hijau</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="bold-title">Tahun</td>
                      <td>:</td>
                      <td>{{faktur.faktur_pkb.service_estimate.vehicle_types.vehicle_production_year}}</td>
                      <td class="bold-title">Phone</td>
                      <td>:</td>
                      <td>{{faktur.faktur_pkb.service_estimate.client.client_phone}}</td>
                      
                    </tr>
                  </table>
                <!-- </td>
              </tr>
            </table> -->

            <table class="table-inside-td" style="width:100%; border: 1px solid black; margin-top: 2px; table-layout: fixed;" >
              <colgroup>
                <col style="width: 20mm">
                <col style="width: 1mm">
                <col style="width: 18.5mm">
                <col style="width: 20mm">
                <col style="width: 1mm">
                <col style="width: 17mm">
                <col style="width: 20mm">
                <col style="width: 1mm">
                <col style="width: 32.5mm">
              </colgroup>
              <tr>
                <td class="bold-title">Tgl. Masuk</td>
                <td>:</td>
                <td>{{faktur.faktur_date_in}}</td>
                <td class="bold-title">KM masuk</td>
                <td>:</td>
                <td colspan="4">{{faktur.faktur_customer_km_in}}</td>
              </tr>
              <tr>
                <td class="bold-title">Tgl. Selesai</td>
                <td>:</td>
                <td>{{faktur.faktur_date_out}}</td>
                <td class="bold-title">KM keluar</td>
                <td>:</td>
                <td>{{faktur.faktur_customer_km_out}}</td>
                <td class="bold-title">SA Kontak</td>
                <td>:</td>
                <td>
                  <span v-if="faktur.faktur_sa_contact==null"></span>
                  <span v-else>{{faktur.faktur_sa_contact}}</span>
                </td>
              </tr>
            </table>
          
            <table style="width:100%; border-collapse: collapse; margin-top: 3mm;" >
              <colgroup>
                <col style="width: 150mm">
                <col style="width: 30mm">
              </colgroup>
              <tr>
                <td class="title-name" style="border:1px solid black; font-weight:bold;">Perincian Tagihan</td>
                <td class="title-name" style="text-align: center; border:1px solid black; font-weight:bold;">BIAYA</td>
              </tr>
            </table>
            <table class="table-inside-td" style="width:100%; border-collapse: collapse; table-layout: fixed;" >
              <colgroup>
                <col style="width: 150mm">
                <col style="width: 30mm ">
              </colgroup>
              <tr style="border-right:1px solid black; border-left:1px solid black;">
                <td class="bold-title" style="padding-left: 25mm; padding-top: 5mm; border-right:1px solid black;">TOTAL BIAYA JASA</td>
                <td  style="padding-top: 5mm;"><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_jasa)}}</span></td>
              </tr>
              <tr style="border-right:1px solid black; border-left:1px solid black; border-bottom:1px solid black;">
                <td class="bold-title" style="padding-left: 25mm; padding-bottom: 5mm; border-right:1px solid black;">TOTAL BIAYA SPAREPART</td>
                <td><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_spare_part)}}</span></td>
              </tr>
            </table>

            <table class="table-inside-td" style="width:100%; border-collapse: collapse; table-layout: fixed; margin-top: 3mm;" >
              <colgroup>
                <col style="width: 120mm; border: 1px solid black;">
                <col style="width: 30mm; border: 1px solid black;">
                <col style="width: 30mm; border: 1px solid black;">
              </colgroup>
              <tr>
                <td class="bold-title" style="text-decoration: underline;">Terbilang :</td>
                <td class="bold-title">Sub Total</td>
                <td><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_jasa + faktur.faktur_total_biaya_spare_part)}}</span></td>
              </tr>
              <tr>
                <td style="padding-left: 20mm;">
                  <span><sub class="bold-title" style="font-size:2.2mm; padding-left:6mm"><i># </i></sub></span>
                  <span style="text-decoration:underline; text-decoration-style: dotted; ">{{faktur.faktur_total_terbilang}}</span>
                  <span ><sub style="font-size:2.2mm " class="bold-title"><i> RUPIAH #</i></sub></span>
                </td>
                <td class="bold-title">PPN 11%</td>
                <td><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_ppn)}}</span></td>
              </tr>
              <tr>
                <td style=""></td>
                <td class="bold-title">Materai</td>
                <td><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_materai)}}</span></td>
              </tr>
              <tr>
                <td style=""></td>
                <td class="bold-title" style="text-align: center; border: 1px solid black;">TOTAL</td>
                <td style="text-align: center; border: 1px solid black;"><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(faktur.faktur_total_biaya_jasa + faktur.faktur_total_biaya_spare_part + faktur.faktur_materai + faktur.faktur_ppn)}}</span></td>
              </tr>
            </table>

            <table class="table-inside-td" style="width:100%; border-collapse: collapse; table-layout: fixed;" >
              <colgroup>
                <col style="width: 22mm">
                <col style="width: 98mm">
                <col style="width: 60mm; border: 1px solid black;">
              </colgroup>
              <tr style="border-left:1px solid black">
                <td class="bold-title" style=" text-decoration: underline; border-bottom: 1px solid black;">Saran : </td>
                <td class="bold-title" style=" border-bottom: 1px solid black;">SERVICE MOBIL KESAYANGAN ANDA DI BENGKEL MSI SERVICE BERIKUTNYA PADA KILOMETER ________ ATAU 3 BULAN BERIKUTNYA</td>
                <td class="bold-title" style="text-decoration: underline; text-align: center;">K A S I R</td>
              </tr>
              <tr style="border-left:1px solid black;">
                <td class="bold-title">Ketentuan:</td>
                <td>
                  <ul style="margin-left:4mm;">
                    <li>Kwitansi dianggap sah apabila sudah dicap/ditandatangani</li>
                    <li>Jaminan pekerjaan berlaku 1 minggu atau 300 KM</li>
                    <li>Kami tidak bertanggung jawab atas hilangnya atau terbuangnya suku cadang bekas kalau tidak diambil dalama waktu 2 haru sejak tanggak perbaikan</li>
                  </ul>
                </td>
                <td></td>
              </tr>
              <tr style="border-left:1px solid black; border-bottom:1px solid black;">
                <td></td>
                <td></td>
                <td style="text-align: center;">
                      <!-- <table>
                        <colgroup>
                          <col style="width: 10%">
                          <col style="width: 80%">
                          <col style="width: 10%">
                        </colgroup>
                        <tr style="text-align: center;">
                          <td>(</td>
                          <td >asdasdda</td>
                          <td>)</td>
                        </tr>
                      </table> -->
                  <sub>(</sub><span style="display:inline-block; border-bottom:1px solid black; padding-left:30px; padding-right:30px;">{{faktur.faktur_kasir_name.name}}</span><sub>)</sub>
                </td>
              </tr>
            </table>
          </md-content>
          <!-- <button class="noprint" @click="printInvoice" >Print Invoice</button>
          <button class="noprint" @click="generateReport" >Print Invoice</button> -->
      </div>
    </div>
    
    <div v-bind:style="{ display: not_found}">
      <center  v-if="faktur == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Go to List Faktur?</a>
        </p>
      </center>
    </div>
  </div>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import angkaTerbilang from '@develoka/angka-terbilang-js';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

  // import InfoCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/InfoCard.vue";
  // import ClientCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ClientCard.vue";
  // import VehicleCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/VehicleCard.vue";
  // import ServiceCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ServiceCard.vue";
  // import PartCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/PartCard.vue";
  
  export default {
     name: "detail-faktur",

    props: {
      // service_estimate: Object,
      data_id:null,
    },

    components: {
      // ValidationError,
      // FormWizard,
      // TabContent,
      // "info-card": InfoCard,
      // "client-card": ClientCard,
      // "vehicle-card": VehicleCard,
      // "service-card": ServiceCard,
      // "part-card": PartCard,
      
    }, 

    mixins: [formMixin],

    data: () => ({
      not_found: 'none',
      role:'',
      faktur: null,
      total_pekerjaan: 0,
      total_part: 0,
      subject: 0,
      ppn: 0,
      total_estimate: 0
    }),

    created() {
      this.getFakturData();
    },

    methods: {
      //fungsi format uang
      formatPrice(value) {
        let val = (value/1).toFixed().replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      //fungsi ambil data faktur dari api dengan id yang dikirim bersamaan melalui route
      async getFakturData(){
        this.role =  await this.$store.getters["role_permission/route_filter"]
        await this.$store.dispatch("workshop_faktur/get", this.data_id.id)
        this.faktur = await this.$store.getters["workshop_faktur/faktur"]
         //check apakah data dari api ada
        if(!this.faktur){
          //jika tidak ada munculkan bagian not found yang defaultnya di hide
          this.not_found = "block"
          return
        }
        
        this.faktur.faktur_total_terbilang =  angkaTerbilang(this.faktur.faktur_total_biaya_jasa + this.faktur.faktur_total_biaya_spare_part + this.faktur.faktur_materai + this.faktur.faktur_ppn)
        console.log(await this.$store.getters["workshop_faktur/faktur"])
       
        
      },

      closeDetail(){
        if(this.data_id.mode && this.data_id.mode == "pkb"){
            this.$parent.$parent.modalCloseshowFaktur();
          }
          else{
            this.$parent.$parent.modalCloseDetail();

          }
      },
      //fungsi untuk pindah ke page edit
      editFaktur(id) {
      this.$router.push({ name: 'Edit Faktur', params: { faktur:id, id } })
      },
      
  //fungsi konfirmasi hapus
    deleteConfirmation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.deleteFaktur(id)
          }
        });
    },
    //fungsi untuk menghapus
    async deleteFaktur(id) {
       try {
         //kirim data yang akan dihapus ke api
          await this.$store.dispatch("workshop_faktur/destroy", id)
          //panggil alert sukses
          await this.$store.dispatch("alerts/success", "Faktur data delete successfully.")
          //kembali ke list
          this.$router.replace({ name: 'List Faktur'})
        } catch (e) {
          //panggil alert gagal
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          //this.setApiValidation(e.response.data.errors)
        }
    },

      //kembali kelist
      async backToList(){
          await this.$router.replace({name: 'List Faktur'})
      },
      //print screen mode
      printPage(){
         window.print()
      }
      
    }
  };
</script>
<style scoped>
.title-name{
  background-color:powderblue;
}
table{
  width:100%;
  table-layout: fixed;
}
.table-kotak{
  border-collapse: collapse;
}
table.table-kotak td{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
table.table-kotak th{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print{
  visibility: hidden;
}
.checkboxes label {
  display: inline-block;
  padding-right: 10px;
  white-space: nowrap;
}
.checkboxes input {
  vertical-align: middle;
}
.checkboxes label span {
  vertical-align: middle;
}
.checkboxes td {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.checkboxes {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.info {
  line-height: 17px;
}
.info td {
margin: 4px;
}
.bold-title{
font-weight:bold;
}
.table-inside-td td {
  vertical-align: top;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
}


@media print{
   .print{
       visibility: visible;
   }
   .noprint{
     display: none;
   }

  
}

.color{
  background-color: #1976d2 !important;
}

</style>